import { useTypedSelector } from '../redux/store';

export function useCurrentNetworkId() {
  const { currentNetworkChainId } = useTypedSelector((state) => state.app);
  return currentNetworkChainId;
}
